var Block_Swiper_Testimonials = {
    init:function(){
        Debug.log("BLOCK SWIPER TESTIMONIALS INIT");

        var swiper = new Swiper(".block-slider-testimonials .slider-container", {
            speed: 600,
            loop: false,
            slidesPerView: 1,
            centeredSlides: false,
            freeMode: false,
            grabCursor: true,
            mousewheel: false,
            slideToClickedSlide: false,
            touchStartPreventDefault: false,
            preventClicks: true,
            spaceBetween:30,
            navigation: {
                nextEl: ".swiper-button-next",
                prevEl: ".swiper-button-prev",
            },
        });

    }
}

$(window).load(function(){
    if($(".block-slider-testimonials").length){
        Block_Swiper_Testimonials.init();
    }
})